import React from 'react'

export const cancelIcon =
    <svg width="20px" height="20px" viewBox="0 0 20 20">
        <g id="Utils" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Styleguides" transform="translate(-491.000000, -1360.000000)">
                <g id="Group-2" transform="translate(0.000000, 1187.000000)">
                    <g id="icon-cancel" transform="translate(489.000000, 171.000000)">
                        <path d="M12,2 C6.47,2 2,6.47 2,12 C2,17.53 6.47,22 12,22 C17.53,22 22,17.53 22,12 C22,6.47 17.53,2 12,2 Z M17,15.59 L15.59,17 L12,13.41 L8.41,17 L7,15.59 L10.59,12 L7,8.41 L8.41,7 L12,10.59 L15.59,7 L17,8.41 L13.41,12 L17,15.59 Z" id="Shape" fill="#000000" fillRule="nonzero"></path>
                        <polygon id="Shape" points="0 0 24 0 24 24 0 24"></polygon>
                    </g>
                </g>
            </g>
        </g>
    </svg>

export const doneIcon =
    <svg viewBox="0 0 18 20">
        <g id="Utils" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Styleguides" transform="translate(-306.000000, -1397.000000)">
                <g id="Group-2" transform="translate(0.000000, 1187.000000)">
                    <g id="icon-done" transform="translate(303.000000, 209.000000)">
                        <path d="M19,3 C20.1,3 21,3.9 21,5 L21,19 C21,20.1 20.1,21 19,21 L5,21 C3.89,21 3,20.1 3,19 L3,5 C3,3.9 3.89,3 5,3 L6,3 L6,1 L8,1 L8,3 L16,3 L16,1 L18,1 L18,3 L19,3 Z M10,17.42 L18,9.42 L16.59,8 L10,14.59 L7.41,12.01 L6,13.42 L10,17.42 Z" id="Shape" fill="#000000" fillRule="nonzero"></path>
                        <polygon id="Shape" points="0 0 24 0 24 24 0 24"></polygon>
                    </g>
                </g>
            </g>
        </g>
    </svg>

export const timerRunningIcon =
    <svg viewBox="0 0 18 18">
        <g id="Utils" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Styleguides" transform="translate(-195.000000, -1399.000000)">
                <g id="Group-2" transform="translate(0.000000, 1187.000000)">
                    <g id="icon-timer-running" transform="translate(192.000000, 209.000000)">
                        <polygon id="Shape" points="0 0 24 0 24 24 0 24"></polygon>
                        <path d="M11,17 C11,17.55 11.45,18 12,18 C12.55,18 13,17.55 13,17 C13,16.45 12.55,16 12,16 C11.45,16 11,16.45 11,17 Z M11,3 L11,7 L13,7 L13,5.08 C16.39,5.57 19,8.47 19,12 C19,15.87 15.87,19 12,19 C8.13,19 5,15.87 5,12 C5,10.32 5.59,8.78 6.58,7.58 L12,13 L13.41,11.59 L6.61,4.79 L6.61,4.81 C4.42,6.45 3,9.05 3,12 C3,16.97 7.02,21 12,21 C16.97,21 21,16.97 21,12 C21,7.03 16.97,3 12,3 L11,3 Z M18,12 C18,11.45 17.55,11 17,11 C16.45,11 16,11.45 16,12 C16,12.55 16.45,13 17,13 C17.55,13 18,12.55 18,12 Z M6,12 C6,12.55 6.45,13 7,13 C7.55,13 8,12.55 8,12 C8,11.45 7.55,11 7,11 C6.45,11 6,11.45 6,12 Z" id="Shape" fill="#000000" fillRule="nonzero"></path>
                    </g>
                </g>
            </g>
        </g>
    </svg>

export const warningIcon =
    <svg viewBox="0 0 22 19">
        <g id="Utils" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Styleguides" transform="translate(-452.000000, -1360.000000)">
                <g id="Group-2" transform="translate(0.000000, 1187.000000)">
                    <g id="icon-warning" transform="translate(451.000000, 171.000000)">
                        <polygon id="Shape" points="0 0 24 0 24 24 0 24"></polygon>
                        <path d="M1,21 L23,21 L12,2 L1,21 Z M13,18 L11,18 L11,16 L13,16 L13,18 Z M13,14 L11,14 L11,10 L13,10 L13,14 Z" id="Shape" fill="#000000" fillRule="nonzero"></path>
                    </g>
                </g>
            </g>
        </g>
    </svg>

export const checkIcon =
    <svg viewBox="0 0 20 16">
        <g id="Utils" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Styleguides" transform="translate(-415.000000, -1362.000000)">
                <g id="Group-2" transform="translate(0.000000, 1187.000000)">
                    <g id="icon-check" transform="translate(413.000000, 171.000000)">
                        <polygon id="Path" fill="#000000" points="8.83333333 19.1675 2.5 12.8341667 4.7325 10.6016667 8.83333333 14.6866667 19.2675 4.2525 21.5 6.50083333"></polygon>
                        <polygon id="Shape" points="0 0 24 0 24 24 0 24"></polygon>
                    </g>
                </g>
            </g>
        </g>
    </svg>


// WEBPACK FOOTER //
// ./src/static/svg/booking-status-badge-icons.js